export default __webpack_public_path__ + "static/media/songkick_badge_pink.ed26cc17.png";